import { createReportUsageTracker } from '@qsrsoft/myq-core';
import { postAPI } from '@/helpers/reportService';

// Report-open tracking for the QSR Soft Admin "Report Usage" tab.
//
// The tracker lives in @qsrsoft/myq-core so every front end records opens the
// same way: it posts "this user opened report X (tab Y)", deduped per org,
// user, report and tab for 10 minutes in localStorage, and the API stamps the
// user, tenant and roles from the verified token. This file only configures
// it for Reports and keeps one shared instance.

export const REPORT_OPEN_URL = 'data_layer/mt/v1/usage/report-open';
export const DASHBOARD_REPORT_ID = 'reports-mtDashboard';
// routes that never got a meta.id report as `name:<route name>`, so no report
// is invisible just because its route is older
export const NAME_ID_PREFIX = 'name:';

const tracker = createReportUsageTracker({
  post: (open) => postAPI(REPORT_OPEN_URL, open),
  namePrefix: NAME_ID_PREFIX,
  routeNameIds: { Home: DASHBOARD_REPORT_ID },
});

/** The usage id for a route: meta.id, the dashboard's id, or `name:<route name>`. */
export const reportIdForRoute = (route) => tracker.reportIdForRoute(route);

/** Post one open, fire and forget; false when deduped or there is no org. */
export const trackReportOpen = (reportId, tab = null) =>
  tracker.trackReportOpen(reportId, tab);

/** Record every report route landing as a report open. */
export const installReportUsageTracking = (router) => tracker.install(router);
